import React from "react";
const IdeaPlanBubbleContent = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-4">
        <div>
          ¿Quieres que tenga en cuenta alguna idea para la planeación de esta
          sesión?
        </div>
        <div>
          Por ejemplo, incorporar pausas activas, implementar actividades que
          requieran uso de material ENAd, incluir desafíos adicionales para los
          estudiantes, etc.
        </div>
      </div>
    </div>
  );
};

export default IdeaPlanBubbleContent;
